























import { defineComponent, watch, ref } from '@vue/composition-api';
import LearnerActivitiesCalender from './components/LearnerActivitiesCalendar.vue';
import Modal from '@/modules/ees/components/Modal.vue'
import CalendarLink from '@/modules/ees/components/CalendarLink.vue';
import { UserStoreKey } from '@/store/StoreInjectionKeys';
import { injectStrict } from '@/lib/utils';

export default defineComponent({
  name: 'LearnerActivities',
  components: {
    LearnerActivitiesCalender,
    Modal,
    CalendarLink
  },
  setup(){
    const userStore = injectStrict(UserStoreKey);
    const showModal = ref(false)

    return {
      showModal,
      userStore
    }
  }
})
